import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
import { offerIncludes } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';

/** The offer — the only block with the price and the real checkout button. */
export function OfferSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="scroll-mt-4 bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-114" data-mp="1fmw4p9mol6lq">
      <div className="mx-auto max-w-5xl" data-id="element-115" data-mp="28a9t2jcbctu8">
        <SectionHeading id="offer-heading" title={<>
              Your Complete <Accent data-id="element-117" data-mp="23g5kxwrbafrk">Teaching System</Accent>
            </>} data-id="element-116" data-mp="28bbftl2oz4rs" />

        <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-[28px] border-2 border-brand-gold/50 bg-white shadow-[0_50px_100px_-50px_rgba(120,90,60,0.5)]" data-id="element-118" data-mp="1yj5fno2adh1i">
          <div className="bg-brand-forest px-6 py-4 text-center" data-id="element-119" data-mp="2r71lbi9u2jaf">
            <p className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-ivory" data-id="element-120" data-mp="3ci1t4fgzd0vs">
              Lash &amp; Brow Instructor Ready™ · by Prof. Kyra
            </p>
          </div>

          <div className="px-6 py-10 sm:px-12" data-id="element-121" data-mp="33pq3gvtoxhgv">
            <img src={MOCKUP_URL} alt="Everything included in Lash & Brow Instructor Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[480px] object-contain" style={{
            filter: 'drop-shadow(0 24px 28px rgba(120, 90, 60, 0.18))'
          }} data-id="element-122" data-mp="33oyj6h5jn65w" />

            <p className="mt-10 text-center font-body text-[12px] font-bold uppercase tracking-[0.18em] text-brand-gold-dark" data-id="element-123" data-mp="2ksf47b826o1f">
              What’s included
            </p>
            <ul className="mx-auto mt-5 grid max-w-xl gap-x-8 gap-y-3.5 sm:grid-cols-2" role="list" data-id="element-124" data-mp="j0af07hy24ue">
              {offerIncludes.map(item => <li key={item} className="flex items-center gap-3 text-[15px] leading-snug text-brand-charcoal sm:text-[16px]" data-id="element-125" data-mp="myhyha3slk9a">
                  <CheckIcon className="h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-126" data-mp="1qy6i8nuur1zi" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-10 border-t border-brand-charcoal/10 pt-9" data-id="element-127" data-mp="1hy9rmgowjt1t">
              <CtaBlock label="Get instant access" showPrice data-id="element-128" data-mp="1i0cpto07kshm" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}